import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class LoyaltyHero {
  constructor() {
    this.$el = document.querySelector(".js-loyalty-hero");

    if (!this.$el) {
      return;
    }
    this.$stage = this.$el.querySelector(".js-loyalty-hero-stage");
    this.$video = this.$el.querySelector(".js-loyalty-hero-video");
    this.$logo = this.$el.querySelector(".js-loyalty-hero-logo");
    this.$title = this.$el.querySelector(".js-loyalty-hero-title");
    this.$cta = this.$el.querySelector(".js-loyalty-hero-cta");

    this.animate();
  }

  animate() {
    gsap.set(this.$background, { opacity: 0 });
    gsap.set(this.$logo, { opacity: 0 });
    gsap.set(this.$title, { opacity: 0 });

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        scrub: true,
        start: "top top",
        end: "bottom -250%",
        duration: 10,
      },
    });

    timeline.fromTo(
      this.$stage,
      {
        yPercent: 0,
      },
      {
        yPercent: -50,
        duration: 1,
        opacity: 0,
        ease: "expo.out",
      }
    );

    gsap.fromTo(
      this.$background,
      {
        scale: 1.5,
        opacity: 0,
      },
      {
        opacity: 1,
        scale: 1,
        duration: 2,
        ease: "expo.out",
      }
    );

    gsap.fromTo(
      this.$logo,
      {
        y: 50,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        delay: 0.25,
        ease: "expo.out",
      }
    );

    gsap.fromTo(
      this.$title,
      {
        y: 50,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        delay: 0.35,
        ease: "expo.out",
      }
    );

    gsap.fromTo(
      this.$cta,
      {
        y: 50,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        delay: 0.45,
        ease: "expo.out",
      }
    );
  }
}
